import React, { useState } from 'react';
import { Modal, Input, Typography, Form, message } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const { Text } = Typography;

// TODO: 联调时替换为接口数据
const MOCK_LANGS = [
    { label: '英语 (美国)', key: 'en-US' },
    { label: '日语 (日本)', key: 'ja-JP' },
    { label: '德语 (德国)', key: 'de-DE' },
    { label: '法语 (法国)', key: 'fr-FR' },
];

/**
 * 多语言翻译弹窗（真实项目为通用 Multilingual 组件）
 * 用法：<MultilingualDialog open title originValue onCancel />
 */
const MultilingualDialog = ({ open, title = '多语言翻译', originValue, onCancel }) => {
    const [values, setValues] = useState({});
    const [form] = Form.useForm();

    const handleOk = () => {
        const configured = Object.values(values).filter(v => v && v.trim()).length;
        message.success(`多语言配置已暂存（已配置 ${configured}/${MOCK_LANGS.length}）`);
        setValues({});
        form.resetFields();
        onCancel();
    };

    const handleCancel = () => {
        setValues({});
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            title={<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><GlobalOutlined style={{ color: '#1890ff' }} /><span>{title}</span></div>}
            open={open}
            onCancel={handleCancel}
            onOk={handleOk}
            width={850}
            okText="确定"
            cancelText="取消"
            styles={{ body: { maxHeight: 600, overflowY: 'auto', padding: '12px 24px' } }}
        >
            <div style={{ marginBottom: 16 }}>
                <div style={{ marginBottom: 8, fontWeight: 500, fontSize: 13, color: '#666' }}>默认展示文案（中文）：</div>
                <div style={{ padding: '10px 16px', background: '#f5f5f5', borderRadius: 6, color: '#333', fontSize: 13, border: '1px solid #eee' }}>
                    {originValue || '暂无文案内容'}
                </div>
            </div>
            <Form form={form} layout="vertical">
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px 24px' }}>
                    {MOCK_LANGS.map(lang => (
                        <Form.Item
                            key={lang.key}
                            label={
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <span style={{ fontWeight: 500 }}>{lang.label}</span>
                                    <Text type="secondary" style={{ fontSize: 12 }}>{lang.key}</Text>
                                </div>
                            }
                            style={{ marginBottom: 0 }}
                        >
                            <Input.TextArea
                                rows={2}
                                placeholder={`请输入${lang.label}翻译内容`}
                                style={{ borderRadius: 6, resize: 'none' }}
                                value={values[lang.key]}
                                onChange={e => setValues(prev => ({ ...prev, [lang.key]: e.target.value }))}
                            />
                        </Form.Item>
                    ))}
                </div>
            </Form>
        </Modal>
    );
};

export default MultilingualDialog;
